import clsx from 'clsx';
import React from 'react';

export default function TechHeading({
  text,
  color = 'bg-current',
  clipPostion = 'top-right',
  classes = null,
  innerClasses = null,
  inlineStyle,
}) {
  return (
    <div style={inlineStyle} className={`inline-flex ${classes && ' ' + classes}`}>
      <p className={clsx(`clip-${clipPostion} ${color} pl-2 pr-5`, innerClasses)}>
        <span className="text-md uppercase tracking-widest text-dark font-bold !leading-tight w-full">{text}</span>
      </p>
    </div>
  );
}
